/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloGrupoActividadEconomica from 'Infotrack@Modelos/administracion/grupoActividadEconomica';
import IGrupoActividadEconomica from 'Infotrack@Modelos/administracion/grupoActividadEconomica/entidades/grupoActividadEconomica';

export default class ControladorModeloGrupoActividadEconomica {
    private modeloGrupoActividadEconomica: ModeloGrupoActividadEconomica;
    constructor() {
        this.modeloGrupoActividadEconomica = new ModeloGrupoActividadEconomica();
    }

    public consultarGrupoActividadEconomica() {
        return this.modeloGrupoActividadEconomica
            .consultarGrupoActividadEconomica()
            .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        await this.modeloGrupoActividadEconomica.crearGrupoActividadEconomica(grupoActividadEconomica);
    }

    public async editarGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        await this.modeloGrupoActividadEconomica.editarGrupoActividadEconomica(grupoActividadEconomica);
    }

    public async eliminarGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        await this.modeloGrupoActividadEconomica.eliminarGrupoActividadEconomica(grupoActividadEconomica);
    }

    public validarEntidad(grupoActividadEconomica: IGrupoActividadEconomica): boolean {
        if (
            grupoActividadEconomica.CodigoGrupoActividadEconomica === '' ||
            grupoActividadEconomica.NombreGrupoActividadEconomica === ''
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
